// This function checks the content of the web page for dictionary terms and replaces them with HTML markup.
async function checkContentForDictionaryTerms() {
    try {
        // Construct the URL for the dictionary JSON data.
        const url = window.sga.root + '?view=dictionary-json';
        // Fetch the dictionary terms from the URL.
        const response = await fetch(url);
        const terms = await response.json();
        // Sort the terms by their length in descending order.
        terms.sort((a, b) => b.term.length - a.term.length);

        // Define the HTML elements to check for dictionary terms.
        const elementsToCheck = 'p, label, a, span';
        const mainContentSelector = '#MainContent';
        // Iterate through the selected elements.
        for (const element of document
            .querySelector(mainContentSelector)
            .querySelectorAll(elementsToCheck)) {
            // Iterate through the dictionary terms.
            for (const term of terms) {
                // Create a regular expression to match the term globally, case-insensitively, and as a whole word.
                const regex = new RegExp(
                    `(?<=>|^|\\b|\\s|[.,])(?:${term.term})(?!\\p{L})(?![^<"]*?(?:"[^"]*"))`,
                    'giu',
                );

                // Replace all occurrences of the term within the element's content.
                let elementHtml = element.innerHTML.replaceAll(regex, (match) => {
                    // Create a replacement HTML markup with the matched term and explanation.
                    return `<span class="dictionary-term-explanation-container" data-term-bubble="${codeTermName(
                        term.term,
                    )}">${match}${term.html}</span>`;
                });

                elementHtml = removeDictionaryFromAttributes(elementHtml);
                element.innerHTML = elementHtml;
            }
        }
        if (terms[0].maxCount) {
            for (const term of terms) {
                // Remove redundant expressions
                const termBubbles = document.querySelectorAll(
                    `[data-term-bubble="${codeTermName(term.term)}"]`,
                );
                for (const termBubble of termBubbles) {
                    const bubble = termBubble.querySelector('.dictionary-term-explanation');
                    if (bubble) {
                        if (term.used >= term.maxCount) {
                            bubble.remove();
                        }
                        term.used++;
                    }
                }
            }
        }
    } catch (error) {
        console.log(error);
    }
}

function codeTermName(term) {
    return window.btoa(encodeURIComponent(term));
}

function removeDictionaryFromAttributes(elementHtml) {
    const regex = /((?:href|title|alt|value|d)=["'][^'"]*)<span class="dictionary-term-explanation-container" data-term-bubble="[^"]*">((?:(?!<\/span>)[\s\S])*?)<span class="dictionary-term-explanation"><span class="dictionary-icon">\?<\/span><span class="inner"><span class="bubble" data-html-base64="[^>]*"><\/span><\/span><\/span><\/span>/g;

    // Use replaceAll to replace all matches with "(.*?)"
    const modifiedHtml = elementHtml.replaceAll(regex, '$1$2');

    return modifiedHtml;
}

// This function removes duplicate dictionary terms from the page.
function clearDuplicatesDictionaryTerms() {
    for (const duplicatedTerm of document.querySelectorAll(
        '.dictionary-term-explanation-container .dictionary-term-explanation-container .dictionary-term-explanation',
    )) {
        const closestContainer = duplicatedTerm.closest('.dictionary-term-explanation-container');
        duplicatedTerm.remove();
        if (closestContainer) {
            // Replace the closest container with its child nodes.
            closestContainer.replaceWith(...closestContainer.childNodes);
        }
    }

    const elementsToCheck = 'p, label, a, span';
    for (const element of document.querySelectorAll(elementsToCheck)) {
        let elementHtml = element.innerHTML;
        elementHtml = removeDictionaryFromAttributes(elementHtml);
        element.innerHTML = elementHtml;
    }
}

// This function decodes and displays dictionary terms that were originally encoded in base64.
function decodeDuplicatesDictionaryTerms() {
    for (const duplicatedTerm of document.querySelectorAll('.dictionary-term-explanation .bubble')) {
        const str = duplicatedTerm.getAttribute('data-html-base64');
        // Decode the base64-encoded HTML and display it within the element.
        const html = decodeURIComponent(escape(window.atob(str)));
        duplicatedTerm.innerHTML = html;
    }
}

// Add an event listener to execute the following code when the DOM is fully loaded.
document.addEventListener('DOMContentLoaded', async function() {
    if (location.pathname === '/pages/glossary-of-terms') {
        // Check if the dictionary is to be used with JavaScript.
        if (window.sga.useDictionary === 'js') {
            // Check if the current page can be a dictionary page.
            const canBeDictionaryPage = document.querySelector('dictionary-section');
            if (!canBeDictionaryPage) {
                // If not, execute the function to check content for dictionary terms.
                await checkContentForDictionaryTerms();
            }
        }
        // If the dictionary is enabled (useDictionary is not empty), clean up and decode dictionary terms.
        if (window.sga.useDictionary !== '') {
            await clearDuplicatesDictionaryTerms();
            await decodeDuplicatesDictionaryTerms();
            // Add a class to the body indicating that the dictionary is loaded.
            document.body.classList.add('--dictionary-loaded');
        }
    }
});
